import { FC, Fragment, useMemo } from 'react';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import {
  LectureVariantEmpty,
  LectureVariantPoster,
  LectureVariantVideo,
  LectureVariantVideoPoster,
} from '@/components/ui/features/lecture/LectureHeaderSection/components/LectureVariants';
import { getLectureVariant } from '@/components/ui/features/lecture/LectureHeaderSection/LectureHeaderSection.utils';
import { LectureVariants } from '@/enums/LectureVariants';
import { queryThinLectureWithTagAndEvent } from '@/fetchers/thinLectures';
import { useResource } from '@/lib/datx-jsonapi-react';

export const LectureMedia: FC = () => {
  const { id: lectureId } = useLecturePageQueryParams();
  const { data: lecture } = useResource(queryThinLectureWithTagAndEvent(lectureId));

  const lectureVariant = useMemo(() => getLectureVariant(lecture), [lecture]);

  // TODO: video does not rerender on page change (4069)
  // key prop enforces this behaviour
  // find the root cause of the issue

  return (
    <Fragment>
      {lectureVariant === LectureVariants.Full && <LectureVariantVideoPoster />}
      {lectureVariant === LectureVariants.Video && <LectureVariantVideo />}
      {lectureVariant === LectureVariants.Poster && <LectureVariantPoster />}
      {lectureVariant === LectureVariants.Empty && <LectureVariantEmpty />}
    </Fragment>
  );
};
